
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useInView } from 'react-intersection-observer';
import Svg from '../../../../components/Svg';
import s from './ArticlePullQuote.module.scss';
const propTypes = {
    quote: PropTypes.shape({
        quoteText: PropTypes.string,
        quoteAttribution: PropTypes.string,
        quoteAttributionTitle: PropTypes.string
    }).isRequired,
    borders: PropTypes.bool,
    animated: PropTypes.bool,
    theme: PropTypes.oneOf(['light', 'dark', 'black']),
    transparent: PropTypes.bool,
    respectLineBreaks: PropTypes.bool
};
const ArticlePullQuote = ({ quote, borders = false, animated = false, theme = 'light', transparent = false, respectLineBreaks = false, }) => {
    const [ref, inView] = useInView({
        threshold: 0.4,
        triggerOnce: true
    });
    return (<div className={cx(s.quote, s[`${theme}Theme`], transparent ? s.transparent : '', { [s.borders]: borders }, { [s.animated]: animated }, { [s.startAnimation]: animated && inView })} ref={ref} data-testid="article-pull-quote">
      <Svg icon="quotes"/>
      <div className={[s.quoteText, respectLineBreaks ? s.showLineBreaks : ''].join(' ')}>
        {quote.quoteText}
      </div>
      <div className={s.quoteAttribution}>{quote.quoteAttribution}</div>
      <div className={s.quoteAttributionTitle}>{quote.quoteAttributionTitle}</div>
      <div className={s.overlay}/>
    </div>);
};
ArticlePullQuote.propTypes = propTypes;
export default ArticlePullQuote;

    async function __Next_Translate__getStaticProps__195ca0cd002__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Article/components/ArticlePullQuote/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0cd002__ as getStaticProps }
  